<template>
    <div id="app">
        <router-view></router-view>

        <b-toast no-auto-hide
                 solid
                 v-model="isUpdateAvailable">
            <template v-slot:toast-title>
                <strong>
                    有可用更新
                </strong>
            </template>
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                    點擊更新👉
                </div>
                <div class="d-flex align-items-center">
                    <button class="btn btn-sm btn-primary px-4"
                            v-on:click="updateApp">
                        重新載入
                    </button>
                </div>
            </div>
        </b-toast>

        <b-toast no-auto-hide
                 solid
                 v-model="isOffline">
            <template v-slot:toast-title>
                <strong>網站離線</strong>
            </template>
            本網站目前處於離線狀態。網站上的信息可能已過期。
        </b-toast>

        <modal-set-password v-bind:token="token"
                            v-model="isModalSetPasswordOpen">
        </modal-set-password>
    </div>
</template>

<script>
import {
    BToast,
} from "bootstrap-vue";
import ModalSetPassword from "./components/modals/ModalSetPassword";

export default {
    components: {
        BToast,
        ModalSetPassword,
    },
    data () {
        return {
            isModalSetPasswordOpen: false,
            token: "",
        };
    },
    computed: {
        user () {
            return this.$store.state.user.user;
        },
        userRole () {
            return this.user.role;
        },
        userStatus () {
            return this.$store.state.user.status;
        },
        isOffline () {
            return !this.$store.getters["layout/isOnline"];
        },
        isUpdateAvailable () {
            return this.$store.getters["layout/isUpdateAvailable"];
        },
        serviceWorker () {
            return this.$store.getters["layout/serviceWorker"];
        },
    },
    methods: {
        updateApp () {
            if (navigator.serviceWorker) {
                if (this.serviceWorker) {
                    let refreshing = false;
                    navigator.serviceWorker.addEventListener(
                        "controllerchange",
                        () => {
                            if (refreshing) {
                                return;
                            }
                            window.location.reload();
                            refreshing = true;
                        }
                    );
                    this.serviceWorker.postMessage({
                        type: "SKIP_WAITING"
                    });
                }
            }
        },
    },
    async created () {
        try {
            await this.$store.dispatch("user/loadToken");
        } catch (e) {
            return;
        }

        let redirect = "/";
        const queryClone = Object.assign({}, this.$route.query);
        if (queryClone.to) {
            redirect = queryClone.to;
            delete queryClone.to;
        }

        this.$router.push(
            {
                "path": redirect,
                "query": queryClone
            }
        );
    },
    mounted () {
        if (
            this.$route.query.setPassword === "true" &&
            this.$route.query.token !== undefined
        ) {
            this.isModalSetPasswordOpen = true;
            this.token = this.$route.query.token;
        }

        window.addEventListener("online", () => this.$store.commit("layout/online"));
        window.addEventListener("offline", () => this.$store.commit("layout/offline"));
    },
    watch: {
        async "userStatus" (newVal) {
            if (newVal === "loggedIn") {
                if (["vending-admin"].includes(this.userRole)) {
                    this.$store.dispatch("users/loadUsers");
                    this.$store.dispatch("users/loadUsersRegularly");
                    this.$store.dispatch("banner/load");
                }

                await Promise.allSettled(
                    [
                        this.$store.dispatch("data/loadSites"),
                        this.$store.dispatch("data/loadCategories"),
                        this.$store.dispatch("data/loadServices"),
                    ]
                );

                try {
                    const stages = await this.$store.dispatch("tasks/getTaskStages");
                    stages.map(
                        ({ _id }) => this.$store.dispatch("tasks/getTasksByStage", _id)
                    );
                } catch (e) {
                    console.error(e);
                }

                //this.$store.dispatch("tasks/listenToTaskStream");
            }
        },
    }
}
</script>

<style lang="scss">
$enable-gradients: true;

@import "~bootstrap/scss/bootstrap";
@import "~bootstrap-vue/src/index";

@import "~vue-select/src/scss/vue-select.scss";

html,
body {
    position: relative;
    //height: 100%;

    background-color: rgba(245, 245, 245, 1);

    font-family:
        -apple-system,
        BlinkMacSystemFont,
        Segoe UI,
        Roboto,
        Helvetica Neue,
        Arial,
        "Microsoft JhengHei",
        sans-serif,
        Apple Color Emoji,
        Segoe UI Emoji,
        Segoe UI Symbol,
        Noto Color Emoji;

    overflow-x: hidden;

    @include media-breakpoint-down(md) {
        overflow-y: hidden;
    }
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.rounded-xl {
    border-radius: 1rem;
}

.btn {
    &.btn-loading {
        position: relative;
        pointer-events: none;
        color: transparent !important;

        &:after {
            position: absolute;
            left: calc(50% - (1em / 2));
            top: calc(50% - (1em / 2));

            display: block;
            height: 1em;
            width: 1em;

            border: 2px solid;
            border-color: rgba(219, 219, 219, 1);
            border-radius: 290486px;
            border-right-color: transparent;
            border-top-color: transparent;

            content: "";

            animation: spinAround .5s infinite linear;
        }
    }
}

@keyframes spinAround {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(359deg);
    }
}

.font-noto-serif-tc {
    font-family: "Noto Serif TC", serif;
}
</style>
